export default __webpack_public_path__ + "static/media/plus.89fe7bf6.svg";